<template>
    <div class="vrm-modal vrm-modal--beta">
        <div class="vrm-modal__title">
            {{ $t('nav.beta_mode') }}
        </div>
        <span class="vrm-modal--beta__message">{{ $t(messageText) }}</span>
        <div class="button-container">
            <a :href="link" class="sg-btn">
                {{ $t(acceptText, { i18nFallback: '' }) }}
            </a>

            <button class="sg-btn" @click="onReset">
                {{ $t('common.cancel', { i18nFallback: 'Cancel' }) }}
            </button>
        </div>
        <modal-close-handle />
    </div>
</template>
<style scoped></style>
<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import ModalCloseHandle from '@/vue/components/modals/ModalCloseHandle';
import { AngularLocaleBundle } from '@/angular-bridge/modules/i18n';
@Component({
    components: { ModalCloseHandle },
})
@AngularLocaleBundle('common')
export default class ConfirmDeletionModal extends Vue {
    @Prop({ type: Boolean, default: true })
    switchToBeta;

    get messageText() {
        return this.switchToBeta ? 'common.beta_switch.text' : 'common.beta_leave.text';
    }

    get acceptText() {
        return this.switchToBeta ? 'common.beta_switch.accept' : 'common.beta_leave.accept';
    }

    get link() {
        return this.switchToBeta
            ? 'https://beta-vrm.victronenergy.com/login'
            : 'https://vrm.victronenergy.com/login';
    }

    onSubmit() {
        $.magnificPopup.close();
    }

    onReset() {
        $.magnificPopup.close();
    }
}
</script>
